module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-places-autocomplete-71f76f0253c27799989db52e5ad2385d.png";